import { ProgressIndicatorItem } from 'components/ProgressIndicator';

import { PAID_NO_FINANCE_BASE_STEPS, REVIEW_STEP } from './constants';

import { LenderStatus } from '../../Content/Lenders/constants';
import {
  getInAwaitDecision,
  getInCompleteJob,
  getInCompletePurchase,
  getInFinished,
  getInNotApproved,
  getInSatNote,
} from '../helpers';

export const getNonFinanceItems = (
  lenderStatus: LenderStatus,
): ProgressIndicatorItem[] => {
  const satNote = getInSatNote(lenderStatus);
  const finished = getInFinished(lenderStatus);
  return [
    ...PAID_NO_FINANCE_BASE_STEPS,
    {
      type: 'multi',
      substeps: [
        {
          active: !satNote && !finished,
          type: 'single',
        },
        {
          active: satNote,
          type: 'single',
        },
        {
          active: finished,
          type: 'single',
        },
      ],
    },
  ];
};

export const getChooseSteps = (
  lenderStatus: LenderStatus,
): ProgressIndicatorItem => {
  const inChoosePaymentStep =
    getInAwaitDecision(lenderStatus) || getInCompletePurchase(lenderStatus);
  if (!inChoosePaymentStep)
    return {
      type: 'single',
      active: false,
    };
  return {
    type: 'multi',
    substeps: [
      {
        active: false,
        type: 'single',
      },
      {
        active: false,
        type: 'single',
      },
      {
        active: getInAwaitDecision(lenderStatus),
        type: 'single',
      },
      {
        active: getInCompletePurchase(lenderStatus),
        type: 'single',
      },
    ],
  };
};

export const getCompleteSteps = (
  lenderStatus: LenderStatus,
): ProgressIndicatorItem => {
  const inChoosePaymentStep =
    getInAwaitDecision(lenderStatus) || getInCompletePurchase(lenderStatus);
  if (inChoosePaymentStep)
    return {
      type: 'single',
      active: false,
    };
  const notApproved = getInNotApproved(lenderStatus);
  if (notApproved)
    return {
      type: 'single',
      active: false,
    };
  return {
    type: 'multi',
    substeps: [
      {
        active: getInCompleteJob(lenderStatus),
        type: 'single',
      },
      {
        active: getInSatNote(lenderStatus),
        type: 'single',
      },
      {
        active: getInFinished(lenderStatus),
        type: 'single',
      },
    ],
  };
};

export const getFinanceItems = (
  lenderStatus: LenderStatus,
): ProgressIndicatorItem[] => {
  const chooseSteps = getChooseSteps(lenderStatus);
  const completeSteps = getCompleteSteps(lenderStatus);
  return [REVIEW_STEP, chooseSteps, completeSteps];
};
